import React from 'react';
import type { Role } from '@/state/AuthContext';

import Dashboard from '@/pages/Dashboard';
import Patients from '@/pages/Patients';
import Appointments from '@/pages/Appointments';
import Settings from '@/pages/Settings';
import AuditLog from '@/pages/AuditLog';
import Login from '@/pages/Login';
import Tasks from '@/pages/Tasks';
import NotificationsPage from '@/pages/Notifications';
import ClientErrors from '@/pages/ClientErrors';

const PatientDetail = React.lazy(() => import('@/pages/PatientDetail'));
const CarePlans = React.lazy(() => import('@/pages/CarePlans'));
const Billing = React.lazy(() => import('@/pages/Billing'));
const OpsBoards = React.lazy(() => import('@/pages/OpsBoards'));

export interface RouteConfig {
  path: string;
  element: React.ReactNode;
  roles: Role[];
}

export const appRoutes: RouteConfig[] = [
  {
    path: '/',
    element: <Dashboard />,
    roles: ['medical_director', 'surgery', 'internal_med', 'customer_service', 'billing'],
  },
  {
    path: '/patients',
    element: <Patients />,
    roles: ['medical_director', 'surgery', 'internal_med'],
  },
  {
    path: '/patients/:patientId',
    element: <PatientDetail />,
    roles: ['medical_director', 'surgery', 'internal_med'],
  },
  {
    path: '/care',
    element: <CarePlans />,
    roles: ['medical_director', 'surgery', 'internal_med'],
  },
  {
    path: '/ops',
    element: <OpsBoards />,
    roles: ['medical_director', 'surgery', 'internal_med', 'billing', 'customer_service'],
  },
  {
    path: '/tasks',
    element: <Tasks />,
    roles: ['medical_director', 'surgery', 'internal_med', 'customer_service'],
  },
  {
    path: '/appointments',
    element: <Appointments />,
    roles: ['medical_director', 'surgery', 'internal_med', 'customer_service'],
  },
  {
    path: '/billing',
    element: <Billing />,
    roles: ['medical_director', 'billing', 'customer_service'],
  },
  {
    path: '/notifications',
    element: <NotificationsPage />,
    roles: ['medical_director', 'surgery', 'internal_med', 'customer_service', 'billing'],
  },
  {
    path: '/audit',
    element: <AuditLog />,
    roles: ['medical_director', 'billing'],
  },
  {
    path: '/admin/errors',
    element: <ClientErrors />,
    roles: ['medical_director', 'billing'],
  },
  {
    path: '/settings',
    element: <Settings />,
    roles: ['medical_director'],
  },
];

export const lazyRouteImporters: Array<() => Promise<unknown>> = [
  () => import('@/pages/PatientDetail'),
  () => import('@/pages/CarePlans'),
  () => import('@/pages/Billing'),
  () => import('@/pages/OpsBoards'),
];

export const publicRoutes = [
  {
    path: '/login',
    element: <Login />,
  },
];
